module.exports = __webpack_public_path__ + "img/calendar-all-used.a841f611.svg";